import { Controller } from "@hotwired/stimulus"
import axios from 'axios';

export default class extends Controller {
  static targets = ["tableView", "toggleButton", "filteredCount", "applicationsCount", "categoryQuery", "customerTypeQuery", "availableAtQuery"]
  static values = { apartmentId: Number }
  filteredCache = null;
  unfilteredCache = null;
  filteredOutCount = 0;
  filteredApplicationsCount = 0;
  allApplicationsCount = 0;
  isFiltered = true;
  params = {};
  sortParams = {};

  connect() {
    this.load()
  }

  async load() {
    await this.fetchData({});
    this.render();
  }

  render() {
  if (this.hasFilteredCountTarget) {
    this.filteredCountTarget.innerHTML = this.filteredOutCount;
  }
  if (this.isFiltered) {
    this.tableViewTarget.innerHTML = this.filteredCache;
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.innerHTML = "<i class='fa fa-toggle-off'></i><span>Näytä</span>";
    }
    if (this.hasApplicationsCountTarget) {
      this.applicationsCountTarget.innerHTML = this.filteredApplicationsCount + " hakijaa";
    }
  } else {
    this.tableViewTarget.innerHTML = this.unfilteredCache;
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.innerHTML = "<i class='fa fa-toggle-on'></i> <span>Näytä</span>";
    }
    if (this.hasApplicationsCountTarget) {
      this.applicationsCountTarget.innerHTML = this.allApplicationsCount + " hakijaa";
    }
  }
}

  async fetchData(params) {
    this.tableViewTarget.innerHTML = "<div>Ladataan...</div>"
    const response = await axios.get(`/admin/apartments/${this.apartmentIdValue}/active_applications/application_stack.json`, { params });
    if (response.status === 200) {
      this.filteredCache = response.data.filtered_html;
      this.unfilteredCache = response.data.html;
      this.filteredApplicationsCount = response.data.filtered_applications_count;
      this.allApplicationsCount = response.data.all_applications_count;
      this.filteredOutCount = response.data.filtered_out_count;
    }
  }

  toggleFilter() {
    this.isFiltered = !this.isFiltered;
    this.render();
  }

  async applyQueries() {
    this.tableViewTarget.innerHTML = "<div>Ladataan...</div>"

    this.updateParams({
      category: this.categoryQueryTarget.value, // Example parameter
      customer_type: this.customerTypeQueryTarget.value,// Another example parameter
      available_at: this.availableAtQueryTarget.value
    });

    await this.fetchData(this.params);
    this.render();
  }

  async sortColumns(event) {
    this.tableViewTarget.innerHTML = "<div>Ladataan...</div>"
   
    var columnName = event.currentTarget.dataset.columnName
    var sortDirection = event.currentTarget.dataset.sortDirection

    Object.assign(this.sortParams, { [columnName]: sortDirection });

    console.log("Event", event.target)
    this.updateParams({
      sort_columns: this.sortParams
    });
    this.toggleSortDirection(event, sortDirection);

    await this.fetchData(this.params);
    this.render();
  }

  updateParams(newParams) {
    Object.assign(this.params, newParams);
  }

  toggleSortDirection(event, sortDirection) {
    if (sortDirection === 'asc') {
      event.currentTarget.classList.remove('sort-asc')
      event.currentTarget.classList.add('sort-desc')
      event.currentTarget.dataset.sortDirection = 'desc'
    } else {
      event.currentTarget.classList.remove('sort-desc')
      event.currentTarget.classList.add('sort-asc')
      event.currentTarget.dataset.sortDirection = 'asc'
    }
  }
}
